import { createRoutesMap } from 'rt-route-map';

export const routesMap = createRoutesMap({
  auth: {
    login: {},
    logout: {},
    registration: {
      ':token': {}
    },
    'reset-password': {
      ':token': {}
    }
  },
  dashboard: {
    profile: {
      edit: {},
      changePassword: {}
    },
    'order-list': {
      issued: {},
      accepted: {},
      'not-confirmed': {},
      'order/:docId': {}
    },
    'stand-list': {
      issued: {},
      accepted: {},
      'stand/:docId': {}
    },
    'client-card': {
      ':id': {}
    },
    'code-status': {},
    scanner: {},
    equipment: {
      ':qr': {}
    },
    'completed-works': {},
    instructions: {},
    telephony: {},
    chat: {
      ':id': {}
    }
  }
});
